module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/gCyfCE/Images/FC-9781528954587.jpg?1684514924812",
      "alt": "This image is the cover for the book White Slave"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("White Slave\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A man who is 6'6\" and nearly 400 pounds casts a big shadow. Charles 'Big Chick' Huntsberry lived beneath his own shadow. He always set out to be the best at what he was doing, to be the top dog. When Chick wins an arm-wrestling contest, it leads him to a profession as a bouncer at the big campus bar. Rumours start to spread about the huge bouncer at the club. Chick starts hearing stories about a guy who would fight a whole motorcycle club and turn over cars. The person in these stories turns out to be Chick himself. An old bouncing associate calls Chick and tells him about a music artist who is looking for a bodyguard. Chick, needing a change, tries it out. The rest is music history.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Charles 'Big Chick' Huntsberry\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("'Big Chick' Huntsberry, who served as Prince's bodyguard from 1980 to 1985, moved with his family from Tennessee to Chanhassen, MN, in 1984 to work with Prince. Chick started a bodyguard school and a ministry after leaving Prince's employment.\tCharles 'Big Chick' Huntsberry passed away from heart failure on 2 April 1990.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0